<template>
  <div class="container">
    <el-row style="width: 100%; height: 100%">
      <el-col :span="16" style="height: 100%; background-color: #e7f1ff">
        <div class="container center col">
          <div class="icon row">
            <el-image style="width: 4vw" :src="icon" :fit="'fit'"></el-image>
            <div class="icon_name">
              <span style="color: #1677ff">庐鸣</span>数据助手
            </div>
          </div>

          <div class="title">庐鸣数据工具服务助手</div>
          <div class="icon_title">方案在手,效率我有,一步到位,决胜在手</div>
          <el-image style="width: 25vw" :src="login_back" :fit="'fit'">
          </el-image>
        </div>
      </el-col>
      <el-col :span="8" style="height: 100%">
        <div class="container register_form col">
          <div class="register_form_title">注册</div>
          <div class="register_way">
            <div
              class="register_email pointer"
              :class="register_way === 0 ? 'is_active' : ''"
              @click="chooseChangeWay(0)"
            >
              注册用户信息
            </div>
          </div>
          <el-form
            :model="register_form"
            :rules="rules"
            ref="registerFormRef"
            style="margin-top: 5vh; width: 100%"
          >
            <el-form-item prop="account">
              <el-input
                v-model="register_form.account"
                :placeholder="inputPlaceholder.account"
              >
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="email">
              <el-input
                v-model="register_form.email"
                :placeholder="inputPlaceholder.emailPlaceholder"
              >
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="register_form.password"
                :placeholder="inputPlaceholder.passwordPlaceholder"
                show-password
              >
                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="againPassword">
              <el-input
                v-model="register_form.againPassword"
                :placeholder="inputPlaceholder.againPasswordPlaceholder"
                show-password
              >
                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item
              class="get_code"
              prop="code"
              v-if="register_way === 0"
            >
              <el-input
                v-model="register_form.code"
                :placeholder="inputPlaceholder.codePlaceholder"
              >
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-mobile-phone"
                ></i>
                <template #append>
                  <el-button
                    :disabled="isDisabled"
                    style="padding: 12px"
                    @click="getEmailCode()"
                    class="get_email_code_but"
                  >
                    {{
                      isCounting > 0 ? `${isCounting}s后重新获取` : "获取验证码"
                    }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-button type="primary" style="width: 100%" @click="registerUser"
              >注册
            </el-button>
          </el-form>
          <div class="copy_right">
            Copyright © 2026 [Gao Mingxing] All Rights Reserved |
            皖ICP备2023004992号
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import icon from "../assets/icon.png";
import login_back from "../assets/login.png";
import { register, sendEmailCode } from "../api";
import { LOGIN_PATH } from "../utilis/enum";

export default {
  name: "Register",

  data() {
    const emailValidate = (rule, value, callback) => {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value === "") {
        callback(new Error("邮箱账号不能为空"));
        return;
      }

      if (!regex.test(value)) {
        callback(new Error("邮箱账号输入有误"));
        return;
      }
      callback();
    };

    const againPasswordValidate = (rule, value, callback) => {
      if (this.register_form.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      }
      callback();
    };

    return {
      icon,
      login_back,
      register_way: 0,
      isCounting: 0,
      isDisabled: false,
      timer: null,
      invitationCode: "",
      register_form: {
        account: "",
        email: "",
        code: "",
        password: "",
        againPassword: "",
      },
      rules: {
        account: [
          { required: true, message: "请输入用户名称" },
          { min: 4, max: 10, message: "长度为4至10个字符" },
        ],
        email: [
          { validator: emailValidate, trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "邮箱长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 6, max: 6, message: "长度为6个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度为6-20个字符", trigger: "blur" },
        ],
        againPassword: [
          { validator: againPasswordValidate, trigger: "blur" },
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度为6-20个字符", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getInvitationFromUrl();
  },
  methods: {
    getInvitationFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      this.invitationCode = urlParams.get("invitation") || "";

      // 如果有邀请码，可以显示提示
      if (this.invitationCode) {
        console.log("检测到邀请码:", this.invitationCode);
        // this.$message.info('您正在使用邀请码注册');
      }
    },

    chooseChangeWay(wayNum) {
      this.register_way = wayNum;
    },

    async registerUser() {
      try {
        // 1. 验证表单
        await this.$refs.registerFormRef.validate();

        // 2. 验证密码一致性
        if (this.register_form.password !== this.register_form.againPassword) {
          this.$message.error("两次输入的密码不一致");
          return;
        }

        // 3. 邮箱格式验证
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(this.register_form.email)) {
          this.$message.error("邮箱格式不正确");
          return;
        }

        // 4. 发送注册请求
        const response = await register(
          this.register_form.account,
          this.register_form.password,
          this.register_form.email,
          this.register_form.code,
          this.invitationCode
        );

        // 5. 处理响应
        if (response.code === 200) {
          this.$message.success("注册成功！");
          setTimeout(() => {
            this.$router.push(LOGIN_PATH);
          }, 1500);
        } else {
          this.$message.error(response.data);
        }
      } catch (error) {
        // 表单验证失败
        if (error instanceof Error) {
          console.error("表单验证失败:", error);
        }
      }
    },

    async getEmailCode() {
      // 验证邮箱是否为空
      if (this.register_form.email === "") {
        this.$message.error("请填写邮箱账号");
        return;
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(this.register_form.email)) {
        this.$message.error("邮箱格式不正确");
        return;
      }

      // 检查是否已经在倒计时中
      if (this.timer) {
        return;
      }

      // 立即开始倒计时
      this.isDisabled = true;
      this.isCounting = 60;

      // 启动倒计时定时器
      this.timer = setInterval(() => {
        if (this.isCounting > 0) {
          this.isCounting--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.isDisabled = false;
        }
      }, 1000);

      try {
        // 发送验证码请求
        await sendEmailCode(this.register_form.email);
        this.$message.success("验证码已发送，请查收邮箱");
      } catch (error) {
        // 请求失败的处理
        console.error("发送验证码失败:", error);
        clearInterval(this.timer);
        this.timer = null;
        this.isDisabled = false;
        this.isCounting = 0;
        this.$message.error("验证码发送失败，请重试");
      }
    },

    navigateForgetView() {
      this.$router.push("/forget");
    },
  },
  computed: {
    inputPlaceholder() {
      if (this.register_way === 0) {
        return {
          account: "请输入用户账户名称",
          emailPlaceholder: "请输入邮箱账号",
          passwordPlaceholder: "请输入密码",
          againPasswordPlaceholder: "请再次输入密码",
          codePlaceholder: "请输入验证码",
        };
      }

      return "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/common/style/index";

$left_size: 15vw;

.icon {
  display: inline-flex;
  padding-left: $left_size;
  align-self: flex-start;
  justify-content: center;
  align-items: center;
  width: fit-content;
  gap: 0.2rem;
  margin-bottom: 2vh;

  .icon_name {
    width: fit-content;
    font-size: 2rem;
    font-weight: bolder;
  }
}

.title {
  color: $main_font_color;
  font-size: 3rem;
  font-weight: bolder;
  align-self: flex-start;
  padding-left: $left_size;
}

.icon_title {
  font-size: 0.8rem;
  color: $help_font_color;
  font-weight: bold;
  align-self: flex-start;
  padding-left: $left_size;
  margin-top: 1vh;
  margin-bottom: 5vh;
}

.register_form {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4vw;
  box-sizing: border-box;

  .register_form_title {
    font-weight: bolder;
    font-size: 1.5rem;
    width: 100%;
  }

  .register_way {
    display: inline-flex;
    line-height: 2vh;
    width: 100%;
    gap: 2vw;
    transition: all 0.1s inherit;
    margin-top: 5vh;

    .register_email {
      color: $help_font_color;
    }

    .register_account {
      color: $help_font_color;
    }

    .is_active {
      border-bottom: solid 0.2rem $main_theme_color;
      padding-bottom: 1vh;
      color: $main_theme_color;
    }

    .get_code {
      display: inline-flex;

      .el-input {
        flex: 1;
      }

      .el-button {
        flex-shrink: 0;
        white-space: nowrap;
      }

      ::v-deep.get_email_code_but {
        &.el-button {
          &:hover,
          &:focus {
            color: $main_theme_color !important;
            border-color: lighten($main_theme_color, 20%) !important;
            background-color: lighten($main_theme_color, 45%) !important;
          }
        }
      }
    }
  }

  .register {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 1vh;
    color: $help_font_color;

    span {
      color: $main_theme_color;
    }

    :nth-child(2) {
      color: $main_theme_color;
    }
  }

  .copy_right {
    font-size: 0.1rem;
    color: $help_font_color;
    margin-top: 15vh;
    text-align: center;
  }
}
</style>
